import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import LoadingOverlay from "react-loading-overlay";

import SearchLimit from "@components/molekul/SearchLimit";
import SearchTable from "../components/SearchTable";
import UploadCSVTemplateApi from "@components/molekul/UploadCSVTemplateApi";

import { SkuProductListLogic } from "./SkuProductList.logic";

LoadingOverlay.propTypes = undefined;

const SkuProductList = () => {
  const {
    listSku,
    columns,
    page,
    sizePerPage,
    totalSize,
    limit,
    loading,
    navigate,
    onTableChange,
    onPageChange,
    onLimitChange,
    handleSearch,
    handleChangeFilter,
    valueFilter,
    onUpload,
    onDownloadUploadPrice,
  } = SkuProductListLogic();

  return (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
          alwaysShowAllBtns: true,
          prePageText: "Sebelumnya",
          nextPageText: "Selanjutnya",
          withFirstAndLast: false,
        })}>
        {({ paginationProps, paginationTableProps }) => (
          <>
            <div className='flex items-center justify-between pb-3 pt-3 md:pt-0'>
              <div className='md:w-1/3'>
                <p className='font-bold text-xl pb-10'>Produk</p>
                <SearchLimit limit={limit} onLimitChange={onLimitChange} />
              </div>
              <div className='w-2/3 justify-end'>
                <div className='flex justify-end mb-2'>
                  <div className='md:w-1/2'>
                    <SearchTable
                      handleSearch={handleSearch}
                      onChangeFilterOpt={handleChangeFilter}
                      filterValues={valueFilter}
                    />
                  </div>
                </div>
                <div className='flex flex-row justify-end mt-3'>
                  <UploadCSVTemplateApi
                    onUpload={onUpload}
                    title='Upload Harga CSV'
                    textButton='Upload Harga CSV'
                    onDownloadTemplate={onDownloadUploadPrice}
                  />
                </div>
              </div>
            </div>
            <div className='table-striped table-responsive'>
              <BootstrapTable
                keyField='id'
                remote
                data={listSku}
                bordered={false}
                loading={loading}
                columns={columns}
                hover
                onTableChange={onTableChange}
                noDataIndication={() => (
                  <div className='text-center'>Empty Data</div>
                )}
                overlay={overlayFactory({
                  spinner: true,
                  background: "rgba(192,192,192,0.3)",
                })}
                {...paginationTableProps}
              />
            </div>
            <div className='flex items-center justify-between'>
              <div>
                <p className='text-muted'>
                  Menunjukan{" "}
                  <span className='font-weight-bold text-dark'>
                    {`${listSku.length}`}
                  </span>{" "}
                  entry
                </p>
              </div>
              <div>
                {listSku.length > 0 && (
                  <PaginationListStandalone
                    {...paginationProps}
                    onPageChange={onPageChange}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </PaginationProvider>
    </div>
  );
};

export default SkuProductList;
